<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('daily_report')">
            <app-default-button
                :title="$fieldTitle('add', 'daily_report', true)"
                v-if="$can('create_daily_report')"
                @click="openModal()"
            />
        </app-page-top-section>

        <app-table
            id="daily-report-table"
            :options="options"
            @action="triggerActions"
        />

        <app-daily-report-create
            v-if="isModalActive"
            v-model="isModalActive"
            @close="isModalActive = false"
            :selected-url="selectedUrl"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('daily-report-table')"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
import {TENANT_BASE_URL} from "../../../../common/Config/UrlHelper";
import DailyReportMixins from "../../Mixins/DailyReportMixins";
import HelperMixin from "../../../../common/Mixin/Global/HelperMixin";
import {urlGenerator} from "../../../../common/Helper/AxiosHelper";

export default {
    name  : "AppDailyReport",
    mixins: [HelperMixin, DailyReportMixins],
    data() {
        return {
            TENANT_BASE_URL,
            isModalActive: false,
            selectedUrl  : '',
        }
    },
    methods: {
        triggerActions(row, action, active) {
            if (action.title === this.$t('detail')) {
                window.location.replace(urlGenerator(`/${TENANT_BASE_URL}daily-report/list/${row.id}/edit`))
            } else if (action.title === this.$t('edit')) {
                this.isModalActive = true;
                this.selectedUrl   = `${TENANT_BASE_URL}app/daily-report/list/${row.id}`;
            } else {
                this.getAction(row, action, active)
            }
        },
        openModal() {
            this.isModalActive = true;
            this.selectedUrl   = ''
        },
    }
}
</script>